<div class="page-container content-w-98">
  <div class="page-head">
    <div class="page-title">
      <p class="headerName">{{ headerData.materialName }}</p>
    </div>
  </div>
  <div>
    <div [ngClass]="{ 'disabled-project': isScreenDisabled }">
      <div class="row" [ngClass]="{ 'disabled-project': checkboxValue }">
        <div
          class="col-md-12"
          *ngrxLet="{
            dataLoaded: (sharedFacade.isLoaded$ | async),
            isClearSearch: (sharedFacade.isClearSearch$ | async)
          } as sharedData"
        >
          <piqet-angular-portlet
            *ngIf="sharedData.dataLoaded"
            [class]="'detail-cell-renderer'"
            [columnDefs]="columnDefs"
            [frameworkComponents]="frameworkComponents"
            [headerBtn]="wholesaleList?.storageList?.length > 0 ? '' : 'Add wholesale data'"
            [gridData]="wholesaleList?.storageList"
            [pageNo]="$any(wholesaleList)?.draw"
            [searchInputSize]="true"
            [hidePagination]="true"
            [hideSearch]="true"
            [createAccess]="showEdit"
            (openBtnModal)="addWholesale(scenarioId, 0, 1, 'Add wholesale')"
            [gridName]="gridName"
            (inlineDataEditEvent)="editRecord($event)"
            [hideSideBar]="isHideSideBar"
            [class]="'fixedHeight'"
            [isClearSearch]="sharedData.isClearSearch"
          ></piqet-angular-portlet>
        </div>
      </div>
    </div>
  </div>
  <piqet-angular-navigation-button [config]="navigationConfig"> </piqet-angular-navigation-button>
</div>
